<div class="flex flex-col mt-5">
  <h6 class="font-semibold text-light text-sm mb-0 uppercase tracking-wide">
    {{ '#ARTIKELINFO.PAGES.DETAIL.UMSATZABFRAGE.TITLE' | translate }}
  </h6>
  <form
    class="flex items-center justify-between gap-3 mb-3 mt-2 border border-solid border-separator p-2"
    [formGroup]="umsatzabfrageForm()"
    (ngSubmit)="onSubmit()"
  >
    <div class="flex flex-col gap-2 md:flex-row md:gap-3 w-full items-center">
      <soft-date-input
        formControlName="from"
        placeholder="Von"
        class="w-full"
      ></soft-date-input>
      <soft-date-input
        formControlName="to"
        placeholder="Bis"
        class="w-full"
      ></soft-date-input>
      <soft-select formControlName="filiale" placeholder="Filiale" class="w-full">
        <soft-select-option value="Alle">Alle</soft-select-option>
        @for (filiale of umsatzabfrageFilialen(); track filiale) {
        <soft-select-option [value]="filiale.vkforg">
          {{ filiale?.vkforg }}
        </soft-select-option>
        }
      </soft-select>
      <button
        type="submit"
        class="soft-button primary w-full md:w-auto md:min-w-[10rem] rounded cursor-pointer"
        [disabled]="umsatzabfrageForm().invalid"
      >
        {{ '#ARTIKELINFO.PAGES.DETAIL.UMSATZABFRAGE.START' | translate }}
      </button>
    </div>
  </form>
  @if (item(); as item) {
  <div
    class="flex flex-col bg-surface border-t border-t-solid border-t-separator border-b border-b-solid border-b-separator"
  >
    <soft-tab-group
      [activatedIndex]="selectedUmsatzabfrageViewIndex() ?? 0"
      (activatedIndexChange)="onTabIndexChanged($event || 0, item)"
    >
      <soft-tab [title]="'VKM'"></soft-tab>
      <soft-tab [title]="'VKerl'"></soft-tab>
      <soft-tab [title]="'VKDB%'"></soft-tab>
      <soft-tab [title]="'EK'"></soft-tab>
    </soft-tab-group>
    <div class="flex px-4 py-2 items-center justify-between w-full bg-surface-secondary">
      <div class="text-[0.825rem] font-semibold w-1/3">
        {{ '#ARTIKELINFO.PAGES.DETAIL.UMSATZABFRAGE.MONTH' | translate }}
      </div>
      <div class="flex items-center justify-between w-full w-2/3">
        @if ({ index: selectedUmsatzabfrageViewIndex() }; as obj) {
        <div
          class="text-[0.825rem] font-semibold flex items-center justify-end text-right w-1/2"
        >
          {{ obj.index === 1 || obj.index === 2 ?
          ('#ARTIKELINFO.PAGES.DETAIL.UMSATZABFRAGE.VALUE' | translate) :
          ('#ARTIKELINFO.PAGES.DETAIL.UMSATZABFRAGE.QTY' | translate) }}
        </div>
        }
        <div
          class="text-[0.825rem] font-semibold flex items-center justify-end text-right w-1/2"
        >
          {{ '#ARTIKELINFO.PAGES.DETAIL.UMSATZABFRAGE.PREV_YEAR' | translate }}
        </div>
      </div>
    </div>
    <div class="flex flex-col bg-surface border-t border-t-solid border-t-separator">
      @if ((data()?.length || 0) > 0) { @for (umsatz of data() | sortFunction: sortByDate;
      track umsatz) { @if (umsatz) {
      <div
        class="flex px-4 py-3 items-center justify-between w-full border-b border-b-solid border-b-separator"
      >
        <div class="w-1/3">
          {{ umsatz.date | date: 'MMMM' }} {{ umsatz.date | date: 'yyyy' }}
        </div>
        @if ( { selectedView: selectedUmsatzabfrageViewIndex() }; as data ) {
        <div class="flex items-center w-2/3">
          <div class="font-semibold flex items-center justify-end text-right w-1/2">
            {{ umsatz?.current | umsatzValueForIndex: data.selectedView || 0 | number:
            '1.2-2' }}
          </div>
          <div class="font-semibold flex items-center justify-end text-right w-1/2">
            {{ umsatz?.vergleich | umsatzValueForIndex: data.selectedView || 0 | number:
            '1.2-2' }}
          </div>
        </div>
        }
      </div>
      } } @if (sum(); as sum) {
      <div
        class="flex px-4 py-3 items-center justify-between w-full border-b border-b-solid border-b-separator bg-secondary-300"
      >
        <div class="w-1/3 font-semibold">SUMME</div>
        @if ( { selectedView: selectedUmsatzabfrageViewIndex() }; as data ) {
        <div class="flex items-center w-2/3">
          <div class="font-semibold flex items-center justify-end text-right w-1/2">
            {{ (data?.selectedView !== 3 ? (sum?.sum?.current | umsatzValueForIndex:
            data.selectedView || 0) : sum?.ekSum?.current?.mengeEinkauf ) | number:
            '1.2-2' }}
          </div>
          <div class="font-semibold flex items-center justify-end text-right w-1/2">
            {{ (data?.selectedView !== 3 ? (sum?.sum?.vergleich | umsatzValueForIndex:
            data.selectedView || 0 : true) : sum?.ekSum?.vergleich?.mengeEinkauf ) |
            number: '1.2-2' }}
          </div>
        </div>
        }
      </div>
      } } @else {
      <div
        class="w-full p-5 text-sm text-light text-center flex items-center justify-center"
      >
        {{ umsatzabfrageForm().valid ? 'Es konnten keine Umsätze gefunden werden' : 'Bitte
        Von- und Bis-Datum eingeben!' }}
      </div>
      }
    </div>
  </div>
  }
</div>
